import parse from 'html-react-parser';
import { t } from 'i18next';

export const htmlParser = (key: string) => {
    return parse(t(key));
};
